var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-card',[_c('v-tabs',[_c('v-tab',{attrs:{"to":{ name: 'CreditorSettingsProfile' },"exact":""}},[_vm._v(_vm._s(_vm.$t('SETTINGS_MY_PROFILE')))])],1),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }